// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2O34o","log":"ModalInventoryLogs_log__36qup","date":"ModalInventoryLogs_date__32ER5","userName":"ModalInventoryLogs_userName__zRAi3"};